(function componentForm($, Adzuki)
{
	"use strict";

	var form = {
		name: 'HotelSearch',
	};

	$(document).ready(function documentReady()
	{
		Adzuki.Form.registerForm(form);
	});

	form.load = function load($form)
	{
		// var $expedia_room_config         = $('.expedia-room-config', $form);
		// var $expedia_room_template       = $expedia_room_config.find('.room.template');
		// var $expedia_room_child_template = $expedia_room_config.find('.child.template');
		// var expedia_room_count           = $expedia_room_config.find('.rooms > .room').length || 1;

		Adzuki.GooglePlaces($form.find('.google-places'));

		// This will stop the checkout date to change automatically
		$('#hotelsearch-checkin').on('dp.change', function populateDropoff(e) {
			var checkout_date = '';

			if ($('#hotelsearch-checkout').val() !== '') {
				checkout_date = Date.parse($('#hotelsearch-checkout').val());
			}

			if (
				e.date
				&& (
					checkout_date === '' ||
					checkout_date <= e.date
				)
			) {
				$('#hotelsearch-checkout').data('DateTimePicker').date(e.date.add(1, 'days'));
			}
		});

		// // add expedia room config
		// $('a.add-room', $expedia_room_config).on('click', function addExpediaRoomConfig(e) {
		// 	var $room,
		// 	    randomInputIndex = Math.floor(Math.random() * 100000);

		// 	e.preventDefault();

		// 	// ADZ-5199 temporary restriction of 4 rooms until/if expedia goes live
		// 	if (expedia_room_count > 4) {
		// 		Adzuki.StatusMessage('info', 'Hotel search only supports up to 4 rooms', 'Max reached');
		// 		return;
		// 	}

		// 	$room = $expedia_room_template.clone();
		// 	$room.find('select:not(.child):disabled').removeAttr('disabled');
		// 	$room.html($room.html().replace(/#room_num#/g, randomInputIndex));
		// 	$room.find('div.children').data('room-number', randomInputIndex);

		// 	// shouldn't be allowed to remove the first room
		// 	if (expedia_room_count <= 1) {
		// 		$room.find('.remove-room').remove();
		// 	}

		// 	// add the sabre room limit separator
		// 	if (expedia_room_count === 5) {
		// 		$room.find('.sabre-room-limit').removeClass('hidden');
		// 	}

		// 	$room.removeClass('template hidden');
		// 	$room.appendTo($expedia_room_config.find('.rooms'));
		// 	expedia_room_count++;
		// 	calculateRoomNumberLabels();
		// });

		// // remove expedia room config
		// $expedia_room_config.on('click', 'a.remove-room', function removeExpediaRoomConfig(e) {
		// 	$(this).parents('.room').remove();
		// 	expedia_room_count--;
		// 	e.preventDefault();
		// 	calculateRoomNumberLabels();
		// });

		// // child ages config
		// $expedia_room_config.on('change', 'select.children', function showChildren() {
		// 	var $self        = $(this),
		// 	    $children    = $self.parent('div').next('.children'),
		// 	    num_children = parseInt($self.val()),
		// 	    $child,
		// 	    child_num;

		// 	$children.html('');

		// 	if (num_children) {
		// 		for (child_num = 1; child_num <= num_children; child_num++) {
		// 			$child = $expedia_room_child_template.clone();
		// 			$child.find(':disabled').removeAttr('disabled');
		// 			$child.find('.child-number').html(child_num);
		// 			$child.html($child.html().replace(/#room_num#/g, $children.data('room-number')));

		// 			$child.removeClass('template hidden');
		// 			$child.appendTo($children);
		// 		}

		// 		$children.removeClass('hidden');
		// 	}
		// 	else {
		// 		$children.addClass('hidden');
		// 	}
		// });

		// // expedia TAAP stuff
		// $('#hotelsearch-expedia_mode').on('change', function expediaTAAP() {
		// 	var $taap  = $('.expedia-taap'),
		// 	    $rates = $('.expedia-rate-type');

		// 	if (this.checked) {
		// 		$taap.show().find('input').prop('disabled', false);
		// 		$rates.show().find('input').prop('disabled', false);
		// 	} else {
		// 		$taap.hide().find('input').prop('disabled', true);
		// 		$rates.hide().find('input').prop('disabled', true);
		// 	}
		// });

		// // default add first room
		// if ($expedia_room_config.find('.room:not(.template)').length === 0) {
		// 	$expedia_room_config.find('.add-room').click();
		// }




		// function calculateRoomNumberLabels() {
		// 	// $.each($form.find('.room:not(.template) span.room-number'), function updateLabel(i, el) {
		// 	// 	this.innerHTML = i+1;
		// 	// });
		// }
	};
}(jQuery, window.Adzuki || {}));
